var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
//components
import { Box } from "@material-ui/core";
import NumberFormat from "react-number-format";
import { FTLPhoneCode } from "./FTLPhoneCode";
import { FTLLabel } from "../FTLLabel";
export const FTLPhoneField = React.forwardRef((_a, ref) => {
    var { label = "", code, phoneCodeComponent, required = false, BoxProps, onChange, mask = "_" } = _a, otherProps = __rest(_a, ["label", "code", "phoneCodeComponent", "required", "BoxProps", "onChange", "mask"]);
    return (React.createElement(Box, Object.assign({}, BoxProps),
        label && React.createElement(FTLLabel, { label: label, required: required }),
        React.createElement(Box, { display: "flex", alignItems: "flex-end" },
            code !== undefined && !phoneCodeComponent && (React.createElement(FTLPhoneCode, null, code)),
            phoneCodeComponent && (React.createElement(Box, { width: 80, height: 40, flexShrink: 0, mr: 2 }, phoneCodeComponent)),
            React.createElement(NumberFormat, Object.assign({ inputRef: ref, onChange: onChange, mask: mask }, otherProps)))));
});
//# sourceMappingURL=index.js.map